export const siteSettings = {
  name: "LQD Finex",
  link: "https://lqdfinex.net",
  email: "support@lqdfinex.net",
  appLink: "https://app.lqdfinex.net",
};
